import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAPI } from '../../API';
import { ActionTypes, useAppDispatch, useAppState } from '../../Store';
import { useTranslation } from '../../Translation';
import SidebarNav from '../../Components/SidebarNav/SidebarNav';
export default function Dashboard() {


    const { translate, language, setLanguage } = useTranslation();
    const api = useAPI();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const appState = useAppState();

    useEffect(() => {
        const { isAuthenticated } = appState;
        if (!isAuthenticated) {
            navigate('/login');
        }
    }, []);
   

    return (
        <div className="flex min-h-full w-full">
            <SidebarNav currentPage="dashboard">
                <div className="flex-1">
                    <h1>Dashboard</h1>
                </div>
            </SidebarNav>
        </div>

    );
}